import { useNotify, useGetOne, useResourceContext, Loading } from 'react-admin'
import { Alert, Card } from '@mui/material'
import { useParams } from 'react-router-dom'
import CurveEditForm from '../../Components/Curves/CurveEditForm'

const CurveEdit = () => {
  const notify = useNotify()
  const resource = useResourceContext()
  const { id } = useParams()
  const entrypoint = process.env.REACT_APP_API_PLATFORM_ENDPOINT

  const { data, isLoading, error } = useGetOne(resource, { id })
  const handleSave = async (payload) => {
    try {
      const response = await fetch(
        `${entrypoint}/services/curve/save/${id.replace('/api/curves/', '')}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      )

      const data = await response.json()

      if (!response.ok)
        throw new Error(data.error_msg ?? 'Failed to update curve.')

      notify('Curve updated', { type: 'success' })
    } catch (e) {
      notify(`Error: ${e.message}`, { type: 'error' })
    }
  }

  if (isLoading) {
    return (
      <>
        <Card>
          <Loading />
        </Card>
      </>
    )
  }

  if (error)
    return (
      <Card>
        <Alert severity="error">Error loading curve</Alert>
      </Card>
    )

  return <CurveEditForm initialData={data} onSubmit={handleSave} />
}

export default CurveEdit
